import React, { useState } from 'react'
import './Preguntas.css'
const Preguntas = () => {
    const [visiblePanel, setVisiblePanel] = useState(null);

    const toggleVisibility = (panel) => {
      setVisiblePanel((prevPanel) => (prevPanel === panel ? null : panel));
    };
    

  return (
    <div className="infoRigth-Content-contentInferior">
        <div className="infoRigth-Content-contentInferior-container">
          <div className="title-content">
            <h4 className="title-content-h4">Preguntas Frecuentes</h4>
          </div>
          <div className="infoRigth-Content-contentInferior-containerCategoria">
            <div
              className="containerCategoria-title"
              onClick={() => toggleVisibility("pregunta1")}
            >
              <h3>¿Cómo funciona la prueba gratuita?</h3>
              <button>
                {visiblePanel === "pregunta1" ? (
                  <i className="fa-solid fa-minus"></i>
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
              </button>
            </div>

            <div
              className={`containerCategoria-info ${
                visiblePanel === "pregunta1" ? "show" : ""
              }`}
            >
              <p>
                Nuestra prueba gratuita de 14 días proporciona acceso inmediato
                a todas las funciones PRO, no necesitas agregar ninguna tarjeta
                de pago.
                <br />
                - 1 Bot <br />
                - 200 Contactos
                <br />
                - ⁠2 Miembros
                <br />
              </p>
            </div>
          </div>

          <div className="infoRigth-Content-contentInferior-containerCategoria">
            <div
              className="containerCategoria-title"
              onClick={() => toggleVisibility("Pregunta2")}
            >
              <h3>
                ¿Las tarifas de WhatsApp Cloud API están incluidas en el plan?
              </h3>
              <button>
                {visiblePanel === "Pregunta2" ? (
                  <i className="fa-solid fa-minus"></i>
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
              </button>
            </div>
            <div
              className={`containerCategoria-info ${
                visiblePanel === "Pregunta2" ? "show" : ""
              }`}
            >
              <p>
                Las tarifas de WhatsApp no están incluidas en la suscripción de
                Chatby, podrá recargar su crédito de WhatsApp directamente en su
                Business Manager. Si supera las 1.000 conversaciones mensuales
                del servicio de WhatsApp, Meta le cobrará las conversaciones
                adicionales. Consulte nuestra <a href='https://chatby.io/calculadora-precios-whatsapp-cloud' target='blank'>calculadora de precios de WhatsApp
                Cloud API</a>  para obtener una estimación de cuál puede ser el
                costo.
              </p>
            </div>
          </div>
          <div className="infoRigth-Content-contentInferior-containerCategoria">
            <div
              className="containerCategoria-title"
              onClick={() => toggleVisibility("Pregunta3")}
            >
              <h3>
                ¿Qué ocurre si alcanzo mi límite de contactos activos mensuales?
              </h3>
              <button>
                {visiblePanel === "Pregunta3" ? (
                  <i className="fa-solid fa-minus"></i>
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
              </button>
            </div>
            <div
              className={`containerCategoria-info ${
                visiblePanel === "Pregunta3" ? "show" : ""
              }`}
            >
              <p>
                Si supera su límite de Contactos Activos Mensuales, sus Bots se
                pausarán inmediatamente. En su lugar, deberá eliminar algunos
                contactos que considere, caso contrario migrar a un plan de más
                contactos. Se recomienda actualizar a un plan más rentable para
                su negocio.
              </p>
            </div>
          </div>
          <div className="infoRigth-Content-contentInferior-containerCategoria">
            <div
              className="containerCategoria-title"
              onClick={() => toggleVisibility("Pregunta4")}
            >
              <h3>
                ¿Puedo cancelar o cambiar mi suscripción en cualquier momento?
              </h3>
              <button>
                {visiblePanel === "Pregunta4" ? (
                  <i className="fa-solid fa-minus"></i>
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
              </button>
            </div>
            <div
              className={`containerCategoria-info ${
                visiblePanel === "Pregunta4" ? "show" : ""
              }`}
            >
              <p>
                Sí, puedes cancelar, actualizar o degradar tu suscripción en
                cualquier momento. No hay un compromiso de tiempo mínimo ni
                permanencia.
                <br />
                Para cancelar, vaya a la sección Facturación de la Plataforma y
                haga clic en Cambiar Plan (Free).
                <br />
                Cuando actualices o reduzcas tu suscripción, tendrás acceso a
                las nuevas opciones de inmediato. Tu próxima factura tendrá un
                importe actualizado a la tarifa.
              </p>
            </div>
          </div>
          <div className="infoRigth-Content-contentInferior-containerCategoria">
            <div
              className="containerCategoria-title"
              onClick={() => toggleVisibility("Pregunta5")}
            >
              <h3>¿Ofrecen pagos anuales y a medida?</h3>
              <button>
                {visiblePanel === "Pregunta5" ? (
                  <i className="fa-solid fa-minus"></i>
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
              </button>
            </div>
            <div
              className={`containerCategoria-info ${
                visiblePanel === "Pregunta5" ? "show" : ""
              }`}
            >
              <p>
                Si, ofrecemos planes anuales y a medida según tus necesidades,
                póngase en contacto con el área de ventas{" "}
                <a href="mailto:ventas@chatby.pe"> ventas@chatby.pe</a>
              </p>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Preguntas
